<template>
    <section class="community">
        <NarrowContent>
            <div class="communityContent">
                <Heading size="xxl">
                    Community Guidelines
                </Heading>
                <time datetime="2022-09-19">
                    Last updated: September 19, 2022
                </time>
                <p>
                    Creatillo is a platform where you can express your creativity and showcase your craft. You can be yourself on Creatillo; it doesn’t matter if you’re a professional artist, a hobbyist or an amateur, you have the chance to express yourself through your art without being discriminated against by algorithms. Our guidelines are responsible for keeping a healthy community where everyone feels safe and acknowledged.
                </p>
                <Heading :h="2" size="xl">
                    Share media only that you have created
                </Heading>
                <p>
                    Creatillo is a place to showcase your craft, not other people’s skills you admire. Only share content that you have rights to share.
                </p>

                <Heading :h="2" size="xl">
                    Post sensitive content with caution
                </Heading>
                <p>
                    Although Creatillo is a place that promotes diversity in art, you should always use the sensitive content option when uploading media related to religious- or political beliefs, or considered erotic- or gore content.
                </p>

                <Heading :h="2" size="xl">
                    Eliminate negativity
                </Heading>
                <p>
                    Creatillo has zero tolerance against sexism, pornography, brutality, terrorism, hate speech, racism and drug usage. Posts that encourage any of these are subjected to removal and may result in suspension of involved accounts.
                </p>

                <Heading :h="2" size="xl">
                    Nurture positive interactions
                </Heading>
                <p>
                    Keep in mind that artistic journeys are long and bumpy which you can either help or harm with certain words or actions. Always aim for helping.
                </p>

                <Heading :h="2" size="xl">
                    Express your thoughts and be authentic
                </Heading>
                <p>
                    Being positive and kind doesn’t mean you can’t have different opinions and thoughts than others. Feel free to express what’s on your mind, but start discussions rather than making statements.
                </p>

                <Heading :h="2" size="xl">
                    Don’t make assumptions quickly
                </Heading>
                <p>
                    In the online space it’s sometimes easy to misunderstand certain messages due to the limitations of non-verbal communication. Before drawing your sword, make sure it’s not just a misunderstanding. For example, sarcasm is something that’s usually hard to get through in writing.
                </p>
            </div>
        </NarrowContent>
    </section>
</template>

<script>
    import NarrowContent from '@/components/layout/NarrowContent'

    export default {
        name: 'Community',
        components: {
            NarrowContent
        },
        metaInfo() {
            if(this.preferences.language === 'hu') {
                return {
                    title: 'Felhasználói Irányelvek | Creatillo',
                    meta: [
                        { vmid: 'description', name: 'description', content: 'Ismerd meg a Creatillo Felhasználói Irányelveit.' }
                    ]
                }
            } else {
                return {
                    title: 'Commmunity Guidelines | Creatillo',
                    meta: [
                        { vmid: 'description', name: 'description', content: 'Learn more about Creatillo\'s Community Guidelines.' }
                    ]
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../scss/variables';

    .community {
        display: flex;
        flex-grow: 1;
    }

    .h1 {
        margin: 0 0 1rem 0;
    }

    .h2 {
        margin: 3rem 0 1rem 0;
    }

    .h3 {
        margin: 2rem 0 1rem 0;
    }

    .h4 {
        margin: 2rem 0 1rem 0;
    }

    ul {
        position: relative;
        margin: 0 0 1.5rem 0;
        padding-left: 2rem;
    }

    li {
        margin: 0 0 1rem 0;
        list-style: none;

        &::before {
            position: absolute;
            content: "\2022";
            display: inline-block;
            color: var(--color-primary-500);
            left: 0;
            line-height: 1.5;
        }

        &:last-of-type {
            margin: 0;
        }
    }

    table {
        border: 1px solid var(--color-grey-150);
        border-spacing: 0;
        border-radius: 0.75rem;
        overflow: hidden;
    }

    th {
        padding: 1rem;
        width: 50%;
        font-family: $font-secondary;
        text-align: left;
        background: var(--color-grey-100);
    }

    td {
        padding: 1rem;
    }

    tr {
        box-shadow: 0 1px 0 0 var(--color-grey-150);

        &:first-of-type, &:last-of-type {
            box-shadow: none;
        }
    }

    time {
        color: var(--color-grey-600);
    }

    .website {
        margin-right: 2.5rem;
    }
</style>